import React, {useState} from 'react'
import axios from 'axios'

function FondosContactoItem(props) {
  const fondoContacto = props.fondo

  const [inputFile, setInputFile] = useState('')
  const [tituloInput, setTituloInput] = useState('')
  const [descInput, setDescInput] = useState('')

  let idElementoNum = fondoContacto.idElement.split('-')[2]
  let tituloString = fondoContacto.title + ''
  let descString = fondoContacto.description + ''

  const onChangeImage = (event) => {
    setInputFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('contacto-fondos-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-marcas-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeTitulo = (event) => {
    setTituloInput(event.target.value)
    document.getElementById('ribbon-marcas-' + idElementoNum).classList.remove('d-none')
  }

  const onChangeDesc = (event) => {
    setDescInput(event.target.value)
    document.getElementById('ribbon-marcas-' + idElementoNum).classList.remove('d-none')
  }

  const uploadFile = () => {
    const url = 'https://puntosurgdl.com/backend/'
    const data = new FormData()

    if (document.getElementById('file-fondo-contacto-' + idElementoNum).files.length !== 0) {
      for (
        let i = 0;
        i < document.getElementById('file-fondo-contacto-' + idElementoNum).files.length;
        i++
      ) {
        data.append(
          'file[]',
          document.getElementById('file-fondo-contacto-' + idElementoNum).files[i]
        )
      }

      data.append('name', props.fondo.idElement)

      axios
        .post(url + 'uploadNewFondoContacto.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            console.log(res.data)
            props.setFondosContacto(res.data.data)
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  return (
    <div className='col-lg-4 fondoContacto-item' key={fondoContacto.idElement}>
      <div className='card card-custom overlay overflow-hidden card-marcas'>
        <div className='card-body p-0'>
          <div
            id={'ribbon-fondo-contacto-' + idElementoNum}
            className='ribbon-label bg-danger d-none'
          >
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img src={fondoContacto.url} alt='' className='w-100 rounded home-fondo-contacto-1' />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-fondo-contacto-' + idElementoNum}
                name={'file-fondo-contacto-' + idElementoNum}
                className='input-image'
                onChange={() => uploadFile()}
                accept='image/*'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary mr-2'
                onClick={() =>
                  document.getElementById('file-fondo-contacto-' + idElementoNum).click()
                }
              />
            </div>
          </div>
          <h3 className='ms-2'>{fondoContacto.title}</h3>
        </div>
      </div>
    </div>
  )
}

export {FondosContactoItem}
